module.exports = __webpack_public_path__ + "assets/src/style/img/here_and_now_in_the_north_map.png?a9ee955c0682c47f742695e489f43ee4";